import { render, staticRenderFns } from "./panelText.vue?vue&type=template&id=7fd0e03a&"
import script from "./panelText.vue?vue&type=script&lang=js&"
export * from "./panelText.vue?vue&type=script&lang=js&"
import style0 from "./panelText.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports